module.exports = __webpack_public_path__ + "img/logo_lxs_v2.ee10ccc6.svg";